module.exports = __webpack_public_path__ + "static/media/restaruantPass.b38e5f74.png";